import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/taaze-logo.svg'
import _imports_1 from '../../assets/images/hamburger-menu-logo.svg'


const _hoisted_1 = { class: "navbar p-0" }
const _hoisted_2 = { class: "container-fluid parent-container justify-content-between" }
const _hoisted_3 = { class: "d-flex d-xl-none align-items-center" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "d-flex d-none d-xl-flex option-container align-items-center" }
const _hoisted_6 = ["href"]

import { TALK_TO_THE_BOOKS_FEEDBACK_FORM } from '@/assets/strings';


export default /*@__PURE__*/_defineComponent({
  __name: 'TaazeNavbar',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("a", {
          class: "navbar-brand logo",
          href: "https:///www.taaze.tw"
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            width: "90",
            height: "20"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: _unref(TALK_TO_THE_BOOKS_FEEDBACK_FORM),
              target: "_blank",
              type: "button",
              class: "d-flex feedback-button justify-content-center align-items-center"
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "d-flex feedback-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 17 18",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M18.43 5.45C18.43 5.06 18.28 4.69 18 4.41L14.01 0.42C13.73 0.15 13.37 0 12.98 0C12.59 0 12.22 0.15 11.95 0.43L0.93 11.44C0.65 11.72 0.5 12.08 0.5 12.48V16.47C0.5 17.28 1.16 17.93 1.96 17.93H5.95C6.34 17.93 6.71 17.78 6.98 17.5L15.34 9.14C15.34 9.14 15.34 9.14 15.35 9.14C15.36 9.14 15.35 9.14 15.35 9.13L17.99 6.49C18.28 6.21 18.43 5.84 18.43 5.45ZM5.94 16.43L2 16.47L1.99 12.5L9.8 4.65L13.76 8.61L5.94 16.43ZM14.82 7.55L10.86 3.59L12.95 1.49L16.94 5.43L14.82 7.55Z",
                    transform: "translate(-1 0)"
                  })
                ])
              ], -1),
              _createElementVNode("div", null, " 體驗回饋 ", -1)
            ]), 8, _hoisted_4)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "option",
            "data-bs-toggle": "offcanvas",
            "data-bs-target": "#navbarDrawer",
            "aria-controls": "navbarDrawer"
          }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "Hamburger Menu"
            })
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=11&amp;k=01&amp;d=00\" target=\"_blank\" class=\"nav-link w-nav-link\" data-v-fa15da74><span class=\"text-span-6\" data-v-fa15da74>中文書</span></a></div><div class=\"option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=11&amp;k=03&amp;d=00\" target=\"_blank\" class=\"nav-link w-nav-link\" data-v-fa15da74><span class=\"text-span-6\" data-v-fa15da74>二手書</span></a></div><div class=\"option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=14&amp;k=01&amp;d=00\" target=\"_blank\" class=\"nav-link w-nav-link\" data-v-fa15da74>電子書</a></div>", 3)),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              href: _unref(TALK_TO_THE_BOOKS_FEEDBACK_FORM),
              target: "_blank",
              type: "button",
              class: "d-flex feedback-button justify-content-center align-items-center"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "d-flex feedback-icon" }, [
                _createElementVNode("svg", {
                  width: "18",
                  height: "18",
                  viewBox: "0 0 17 18",
                  fill: "currentColor",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M18.43 5.45C18.43 5.06 18.28 4.69 18 4.41L14.01 0.42C13.73 0.15 13.37 0 12.98 0C12.59 0 12.22 0.15 11.95 0.43L0.93 11.44C0.65 11.72 0.5 12.08 0.5 12.48V16.47C0.5 17.28 1.16 17.93 1.96 17.93H5.95C6.34 17.93 6.71 17.78 6.98 17.5L15.34 9.14C15.34 9.14 15.34 9.14 15.35 9.14C15.36 9.14 15.35 9.14 15.35 9.13L17.99 6.49C18.28 6.21 18.43 5.84 18.43 5.45ZM5.94 16.43L2 16.47L1.99 12.5L9.8 4.65L13.76 8.61L5.94 16.43ZM14.82 7.55L10.86 3.59L12.95 1.49L16.94 5.43L14.82 7.55Z",
                    transform: "translate(-1 0)"
                  })
                ])
              ], -1),
              _createElementVNode("div", null, " 體驗回饋 ", -1)
            ]), 8, _hoisted_6)
          ])
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"offcanvas offcanvas-end canvas\" tabindex=\"-1\" id=\"navbarDrawer\" aria-labelledby=\"navbarDrawerLabel\" data-v-fa15da74><div class=\"offcanvas-body\" data-v-fa15da74><ul class=\"navbar-nav\" data-v-fa15da74><li class=\"nav-item option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=11&amp;k=01&amp;d=00\" target=\"_blank\" class=\"nav-link\" data-v-fa15da74>中文書</a></li><li class=\"nav-item option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=11&amp;k=03&amp;d=00\" target=\"_blank\" class=\"nav-link\" data-v-fa15da74>二手書</a></li><li class=\"nav-item option\" data-v-fa15da74><a href=\"https://www.taaze.tw/rwd_list.html?t=14&amp;k=01&amp;d=00\" target=\"_blank\" class=\"nav-link\" data-v-fa15da74>電子書</a></li></ul></div></div>", 1))
  ], 64))
}
}

})